
import React, { Component } from 'react';
import { PointForm } from 'components/Point/Form';
import {FormContext, FormProvider} from 'core/FormProvider';
import { YellowButton } from 'ui/Button';


export class EditPointDialog extends Component {

  handlePostSave = (item) => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { item } = this.props;
    return (
      <FormProvider
        url={item.meta.url}
        postSave={(item) => this.handlePostSave(item)}
        postSaveMessage={'Точка обновлена'}
        item={item}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <React.Fragment>

              <PointForm />

              <div className={'mt-30'}>
                <YellowButton
                  size={'large'}
                  onClick={(e) => context.handleSubmit(e)}
                  disabled={loading}
                >
                  Обновить точку
                </YellowButton>

              </div>
            </React.Fragment>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
